import React, { FC } from 'react';
import { Button } from '@sravni/react-design-system/lib/Button';
import { SubmitButton, useBehaviourState } from '@sravni/react-silent-authentication-form';
import { useFormContext } from 'react-hook-form';
import { useIsMobile } from '@sravni/react-utils';
import cn from 'classnames';
import { ConsentsScreenTexts } from '../ConsentsScreen.texts';
import { FIELD_NAME, FORM_ID, UNAUTHORIZED_ERROR_TYPE } from '../../../constants';
import { ContentProps } from '../types';

type ConsentsSubmitButtonProps = Pick<ContentProps, 'onConsentsSubmitClick'> & {
    onReturnButtonClick: () => void;
};

export const ConsentsSubmitButton: FC<ConsentsSubmitButtonProps> = (props) => {
    const { onReturnButtonClick, onConsentsSubmitClick } = props;
    const { formState, watch } = useFormContext();
    const { errors } = formState || {};
    const { isLoading } = useBehaviourState();
    const isMobile = useIsMobile();

    const [agreementPersonalData] = watch([FIELD_NAME.AGREEMENT_PERSONAL_DATA]);

    const isUnauthorizedError = errors[FIELD_NAME.SERVER]?.type === UNAUTHORIZED_ERROR_TYPE;

    if (isUnauthorizedError) {
        return (
            <Button
                size={52}
                className={cn({ 'h-mt-24': !isMobile })}
                onClick={onReturnButtonClick}
                block
                variant="primary"
                color="dark">
                {ConsentsScreenTexts.TryAgainButtonLabel}
            </Button>
        );
    }

    if (!agreementPersonalData) {
        return (
            <Button size={52} className={cn({ 'h-mt-24': !isMobile })} form={FORM_ID} disabled>
                {ConsentsScreenTexts.ContinueButtonLabel}
            </Button>
        );
    }

    return (
        // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
        <div onClick={onConsentsSubmitClick}>
            <SubmitButton size={52} className={cn({ 'h-mt-24': !isMobile })} form={FORM_ID} loading={isLoading}>
                {ConsentsScreenTexts.ContinueButtonLabel}
            </SubmitButton>
        </div>
    );
};
